/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import { slug } from '../../../../common';
import AbstractInput from './AbstractInput';
import CoreSwitch from 'flarum/common/components/Switch';

const t = app.translator.trans.bind(app.translator);
const prfx = `${slug}.forum.banner_form.inputs.labels`;

export default class Switch extends AbstractInput {
	get defaultValue() {
		return false;
	}

	className() {
		return `${super.className()} ${super.className()}--switch`;
	}

	content() {
		const { name } = this.attrs;

		return [
			<CoreSwitch state={this.value() || false} onchange={this.value}>
				{t(`${prfx}.${name}`)}
			</CoreSwitch>,
		];
	}
}
